import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";

export interface FlexIsDetailsService {
    getFlexIsDetails(shopId: string, startDate: Date, endDate: Date): angular.IPromise<apsViewModels.FlexIsDetailsInfo>;
}

class FlexIsDetailsServiceImpl implements FlexIsDetailsService {
    private httpService: HttpService;

    constructor(httpService: HttpService) {
        this.httpService = httpService;
    }

    getFlexIsDetails(shopId: string, startDate: Date, endDate: Date): angular.IPromise<apsViewModels.FlexIsDetailsInfo> {
        return this.httpService.get(
            Endpoints.FLEX_IS_DETAILS,
            {
                shopId: shopId,
                startDate: startDate,
                endDate: endDate
            });
    }
}

export default angular
    .module('aps.services.flexIsDetailsService', [HttpServiceName])
    .service('flexIsDetailsService', FlexIsDetailsServiceImpl)
    .name;


// WEBPACK FOOTER //
// ./src/app/services/machineDetails/flexIsDetails.service.ts